import {
  InputField,
  PasswordInputField,
  PhoneInputField,
  SelectFieldForId,
} from "components/Common/input-fields"
import Notify from "components/Common/notify"
import { useCallback, useEffect, useRef, useState } from "react"
import Flatpickr from "react-flatpickr"
import { useSelector, useDispatch } from "react-redux"
import {
  allStaffs,
  StaffCreate,
  StaffUpdate,
} from "redux/slice/staff/staffSlice"
import PersonalInfoForm from "./formSections/personal"
import AcademicsInfoForm from "./formSections/academics"
import EducationExpensesInfoForm from "./formSections/education-expenses"
import AuthorizationInfoForm from "./formSections/authorization"
import ReferenceInfoForm from "./formSections/reference"
import DocumentsInfoForm from "./formSections/documents"
import {
  allApplications,
  ApplicationFetch,
  ReturningStudentDetailFetch,
  ApplicationQuestions,
  DiscripantApplication,
  GetMiscellaneousDocs,
  SelectingCurrentApplication,
  SendRecommendation,
} from "redux/slice/applications/applicationSlice"
import { MapDataToApplicationState } from "utilities/mapDataToApplicationState"
import Loader from "components/Common/loader"
import ApplicationComments from "./application-comments"
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom"
import SideChat from "./side-chat"
import {
  Card,
  CardBody,
  CardFooter,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
} from "reactstrap"
import ReactQuill from "react-quill"
import MiscDocs from "./miscellaneous-docs"
import ApplicationRecommendation from "./application-recommendation"
import { getUserTokenID, getUserTokenRole } from "utilities/parse-jwt"
import { userData } from "redux/slice/user/userSlice"
import { SHUK_ROLE_VIWEWER } from "redux/enums"

export default function ApplicationForm(props) {
  const navigate = useNavigate()
  const { applicationId } = useParams()
  const [searchParams] = useSearchParams()
  const _recommendationParamFlag = searchParams.get("recommendation")
  // `focus` comes from notification clicks: "chat" opens the Message Applicants
  // tab, "documents" scrolls to the Documents Details section.
  const _focusParam = searchParams.get("focus")
  const hasScrolledToDocs = useRef(false)
  const dispatch = useDispatch()
  const { userRole } = useSelector(userData) 
  const {
    singleApplicationDetail,
    loading,
    statusUpdateLoading,
    applicationsQuestions,
    currentApplicationSelected,
  } = useSelector(allApplications)
  const { staffMembersData } = useSelector(allStaffs) || {}

  // Guard: only allow status update once the applicant's name and applicationId
  // are actually loaded, so we never send/show an undefined name or empty id.
  const _statusApplicationId = currentApplicationSelected?.applicationId
  const canUpdateStatus =
    !!currentApplicationSelected?.firstName &&
    _statusApplicationId !== undefined &&
    _statusApplicationId !== null &&
    _statusApplicationId !== ""

  const [role, setRole] = useState("")
  const [forView, setForView] = useState(true)
  const [openDropdown, setOpenDropdown] = useState(false)
  const [miscDocsModalState, setMiscDocsModalState] = useState(false)
  const [recommendationState, setRecommendationState] = useState(false)
  const [recommendationValues, setrecommendationValues] = useState("")
  const [staffAssigned, setStaffAssigned] = useState(false)
  const [recommendationStatusUpdate, setRecommendationStatusUpdate] = useState({
    errorCode: 0,
  })
  const [tabSwitch, setTabSwitch] = useState("notes")
  const [discrepantModalState, setDiscrepantModalState] = useState(false)
  const [discrepant, setDiscrepant] = useState({
    status: "No",
    comments: "",
  })
  const [selectedId, setSelectedId] = useState(false)
  const [formDataState, setFormDataState] = useState({
    // personal details
    personal: {
      firstName: "",
      middleName: "",
      lastName: "",
      dateOfBirth: "",
      email: "",
      phoneNumber: "+92",
      fatherFirstName: "",
      fatherMiddleName: "",
      fatherLastName: "",
      motherFirstName: "",
      motherMiddleName: "",
      motherLastName: "",
      isOldStudent: "",
      isDiscrepent: false,
      homeAddress: "",
      alternateAddress: "",
      postalCode: "",
      alternatePhoneNumber: "",
      country: "",
      state: "",
      city: "",
      pakistanOTFCode: "",
      fatherOccupation: "",
      motherOccupation: "",
      annualIncome: "",
      incomeCurrency: "",
      houseStatus: "",
      totalHouseholdMembers: "",
      parentsOccupationDetails: "",
      householdDetails: [
        {
          name: "",
          age: "",
          relationship: "",
          occupation: "",
          annualIncome: "",
        },
      ],
    },
    // accademic info
    academics: {
      instituteName: "",
      affliatedUniversity: "",
      instituteWebsite: "",
      instituteAddress: "",
      city: "",
      pinCode: "",
      country: "",
      programName: "",
      programCurrentYear: "",
      programDuration: "",
      programStartDate: "",
      instituteAdditionalInfo: "",
    },
    // education epenses
    educationExpenses: {
      currency: "",
      expenseList: [
        {
          expense: "Tuition Expenses",
          total: 40000,
          Year1: 10000,
          Year2: 10000,
          Year3: 10000,
          Year4: 10000,
        },
      ],
      educationExpense: "",
      otherExpense: "",
      aboutShukreIlahi: "",
    },
    // documents details
    documents: {
      nicImage: [],
      nicImageBack: [],
      passportSizePicture: [],
      addmissionLettter: [],
      tutionFeeSchedule: [],
      marksheet: [],
      incomeVerification: [],
      feeReceiptsImage: [],
      miscellaneousExpense: [],
      otherDocuments: [],
      description: "",
    },
    // reference details
    refernce: {
      refernceDetails: [
        {
          name: "",
          email: "",
          phoneNumber: "",
          relationshipWithApplicant: "",
          coverLetterImageUrl: "",
        },
      ],
    },
    // authorization details
    authorization: {
      answers: [],
      applicationConsideration: "",
      signature: [],
      place: "",
      submittedDate: "",
      ipAddress: "",
    },
  })

  const isViewer = userRole === SHUK_ROLE_VIWEWER

  // // console.log("searchParams", applicationsQuestions, currentApplicationSelected)
  // const [formDataState, setFormDataState] = useState({
  //   // personal details
  //   personal: {
  //     firstName: "Ali",
  //     middleName: "Ahmed",
  //     lastName: "Khan",
  //     dateOfBirth: "1995-05-15",
  //     email: "ali.khan@example.com",
  //     phoneNumber: "+923001234567",
  //     fatherFirstName: "Mohammad",
  //     fatherMiddleName: "Ali",
  //     fatherLastName: "Khan",
  //     motherFirstName: "Fatima",
  //     motherMiddleName: "Bibi",
  //     motherLastName: "Khan",
  //     homeAddress: "123 Main Street, Karachi",
  //     alternateAddress: "456 Secondary Street, Karachi",
  //     postalCode: "75500",
  //     alternatePhoneNumber: "+923007654321",
  //     country: "Pakistan",
  //     state: "Sindh",
  //     city: "Karachi",
  //     fatherOccupation: "Engineer",
  //     motherOccupation: "Teacher",
  //     annualIncome: 2000,
  //     houseStatus: "owned",
  //     totalHouseholdMembers: 3,
  //     householdDetails: [
  //       {
  //         name: "Mariya",
  //         age: "19",
  //         relationship: "Daughter",
  //         occupation: "Student",
  //         annualIncome: 100,
  //       },
  //     ],
  //   },
  //   // academic info
  //   academics: {
  //     instituteName: "Karachi University",
  //     affliatedUniversity: "University of Karachi",
  //     instituteWebsite: "http://www.uok.edu.pk",
  //     instituteAddress: "University Road, Karachi",
  //     city: "Karachi",
  //     pinCode: "75270",
  //     country: "Pakistan",
  //     programName: "Computer Science",
  //     programCurrentYear: "3",
  //     programDuration: "4 years",
  //     programStartDate: "2025-05-15",
  //     instituteAdditionalInfo: "This is best institute for science subjects",
  //   },
  //   // education expenses
  //   educationExpenses: {
  //     currency: "PKR",
  //     expenseList: [
  //       {
  //         expense: "Tuition Expenses",
  //         total: 40000,
  //         Year1: 10000,
  //         Year2: 10000,
  //         Year3: 10000,
  //         Year4: 10000,
  //       },
  //     ],
  //     educationExpense: 1000,
  //     otherExpense: 500,
  //     aboutShukreIlahi:
  //       "ShukreIlahi is a scholarship program aimed at supporting students in need.",
  //   },
  //   // documents details
  //   documents: {
  //     nicImage: ["nic_image.jpg"],
  //     passportSizePicture: ["passport_photo.jpg"],
  //     addmissionLettter: ["admission_letter.pdf"],
  //     tutionFeeSchedule: ["tuition_fee_schedule.pdf"],
  //     marksheet: ["marksheet.pdf"],
  //     incomeVerification: ["income_verification.pdf"],
  //     feeReceiptsImage: ["boarding_bills.pdf"],
  //     miscellaneousExpense: ["misc_expense.pdf"],
  //     otherDocuments: ["other_docs.pdf"],
  //   },
  //   // reference details
  //   refernce: {
  //     refernceDetails: [
  //       {
  //         firstName: "Sarah",
  //         middleName: "A.",
  //         lastName: "Khan",
  //         contactNo: "+92 300 1122334",
  //         alternateContactNo: "+92 300 2233445",
  //         email: "sarah.khan@example.com",
  //         address: "456 Elm Street",
  //         city: "Karachi",
  //         country: "Pakistan",
  //         pinCode: "75270",
  //         relation: "Professor",
  //       },
  //     ],
  //   },
  //   // authorization details
  //   authorization: {
  //     applicationConsideration:
  //       "I hereby authorize the verification of the information provided.",
  //     signature: [
  //       "https://www.shutterstock.com/image-vector/handwritten-signature-signed-papers-documents-260nw-2248268539.jpg",
  //     ],
  //     place: "Karachi",
  //     submittedDate: "2024-10-16",
  //     ipAddress: "192.168.1.1",
  //   },
  // })

  const findUserRole = async () => {
    let usertokenRole = await getUserTokenRole()
    // // console.log("Role detected: ", usertokenRole)
    setRole(usertokenRole)
  }

  const handleCloseMiscDocs = () => {
    setMiscDocsModalState(false)
  }

  const handleOpenMiscDocs = () => {
    dispatch(GetMiscellaneousDocs(currentApplicationSelected?.id))
    setMiscDocsModalState(true)
  }

  const handlerecommendationValuesChange = value => {
    // console.log("recom value html" ,value)
    setrecommendationValues(value)
  }

  const handleSelectRecommendationChange = (id, value) => {
    // Accepted, Hold, Rejected
    // `${currentApplicationSelected?.firstName + " "}${currentApplicationSelected?.middleName ? currentApplicationSelected?.middleName + " " : ""}${currentApplicationSelected?.lastName ? currentApplicationSelected?.lastName : ""}`,
    setRecommendationStatusUpdate(prev => ({
      ...prev,
      id,
      [id]: value,
      type: value,
    }))
    
    const nameSource =
      currentApplicationSelected?.firstName ||
      currentApplicationSelected?.lastName
        ? currentApplicationSelected
        : formDataState?.personal || {}
    let fullname = [
      nameSource?.firstName,
      nameSource?.middleName,
      nameSource?.lastName,
    ]
      .filter(Boolean)
      .join(" ")
    const predefinedValues = {
      Accepted: `<p><span style="color: black;">Congratulations &nbsp;${fullname}</span>,</p><p><span style="color: black;">&nbsp;</span></p><p><span style="color: black;">The Shukre Ilahi Board has approved your application for a scholarship. We are pleased to award you financial support towards your education. The award is for your tuition fees in the amount communicated to you in the application portal, until your graduation.</span></p><p><br></p><p><span style="color: black;">Please note that this scholarship, is subject to you maintaining your academic performance and attendance record. It is your responsibility to provide evidence of this. </span></p><p><br></p><p><span style="color: black;">All communication with you will be through your portal, you will have access to it for the entire time that we are giving you financial assistance.&nbsp;</span></p><p><br></p><p><span style="color: black;">To assist us with a timely remittance of your tuition fees you are required to log in to your portal and upload:</span></p><ul><li><span style="color: black;">your</span><strong style="color: black;"> mark sheet each semester </strong><span style="color: black;">before a payment can be made for a subsequent term. Failure to do this will result in a delay in your payment.</span></li><li>inform Shukre Ilahi of your <strong>fee due</strong> <strong>date</strong> as soon as it is sent to you each semester, failure to send us fee due dates in a timely manner will result in you not getting your fees paid.</li></ul><p><br></p><p><span style="color: black;">Payments for subsequent years will depend on the availability of funds and, therefore subject to change.</span></p><p><span style="color: black;">Your fees will be sent directly to your institution from our local agents. </span></p><p><br></p><p><span style="color: rgb(192, 0, 0);">For students in India only. </span><span style="color: black;">Visit </span><a href="https://app.shukreilahi.org/assets/Moeen.pdf" download="Moeen.pdf" target="_blank" rel="noopener noreferrer">https://app.shukreilahi.org/assets/Moeen.pdf</a><span style="color: rgb(192, 0, 0);"></span><span style="color: black;">.&nbsp;Print the form and fill in your details.&nbsp;Send a hard copy of the form and all required documents by courier or registered post to Moeen’s office. </span></p><p><br></p><p><span style="color: rgb(192, 0, 0);">For students in Pakistan only. - </span><span style="color: black;">You are required to fill out the form below for OTF</span></p><p><a href="https://docs.google.com/forms/d/e/1FAIpQLScdydwol0h01tSYtPlH_NNiKrssWnX-W-MWlsoeZhFQHN8D5w/viewform" rel="noopener noreferrer" target="_blank">https://docs.google.com/forms/d/e/1FAIpQLScdydwol0h01tSYtPlH_NNiKrssWnX-W-MWlsoeZhFQHN8D5w/viewform</a><span style="color: rgb(192, 0, 0);"> </span></p><p><br></p><p><span style="color: black;">We, at Shukre Ilahi, strongly feel that lack of funds should not be a barrier for a good and deserving student to achieve academic success. Therefore, we encourage you to help other students, such as yourself, by donating back to the Shukre Ilahi Scholarship Fund once you graduate and can do so. When you are ready to donate back, please contact us for details of your local Shukre Ilahi agents.</span></p><p><br></p><p><span style="color: black;">Our Best Wishes are always with you for continued success in your chosen career path.</span></p><p><span style="color: black;">Salaams,</span></p><p><br></p><p><span style="color: black;">The Shukre Ilahi Board.</span></p><p><span style="color: black;">&nbsp;</span></p>`,
      AcceptedPK: `<p><span style="color: black;">Congratulations &nbsp;${fullname}</span>,</p></p><p><br></p><p><span style="color: black;">The Shukre Ilahi Board has approved your application for a scholarship. We are pleased to award you financial support towards your education. The award is for your tuition fees in the amount communicated to you in the application portal, until your graduation.</span></p><p><br></p><p><span style="color: black;">Please note that this scholarship, is subject to you maintaining your academic performance and attendance record. It is your responsibility to provide evidence of this.&nbsp;</span></p><p><br></p><p><strong>All communication with you will be through your portal, you will have access to it for the entire time that we are giving you financial assistance.&nbsp;Please note that we will not respond to emails.</strong></p><p><br></p><p><span style="color: black;">To assist us with a timely remittance of your tuition fees you are required to log in to your portal and upload:</span></p><ul><li>Your<strong> mark sheet each semester </strong>before a payment can be made for a subsequent term. Failure to do this will result in a delay in your payment.</li><li><span style="color: black;">Inform Shukre Ilahi of your </span><strong>fee due</strong> <strong>date/challan</strong> as soon as it is sent to you each semester, failure to send us fee due dates in a timely manner will result in you not getting your fees paid. </li></ul><p><br></p><p>Payments for subsequent years will depend on the availability of funds and, therefore subject to change.</p><p><span style="color: black;">Your fees will be sent directly to your institution from our local agents.&nbsp;</span></p><p><br></p><p><span style="color: black;">We, at Shukre Ilahi, strongly feel that lack of funds should not be a barrier for a good and deserving student to achieve academic success. Therefore, we encourage you to help other students, such as yourself, by donating back to the Shukre Ilahi Scholarship Fund once you graduate and can do so. When you are ready to donate back, please contact us for details of your local Shukre Ilahi agents.</span></p><p><br></p><p><span style="color: black;">Our Best Wishes are always with you for continued success in your chosen career path.</span></p><p><br></p><p><span style="color: black;">Salaams,</span></p><p><span style="color: black;">The Shukre Ilahi Board.</span></p>`,
      AcceptedIN: `<p><span style="color: black;">Congratulations &nbsp;${fullname}</span>,</p><p><br></p><p><span style="color: black;">The Shukre Ilahi Board has approved your application for a scholarship. We are pleased to award you financial support towards your education. The award is for your tuition fees in the amount communicated to you in the application portal, until your graduation.</span></p><p><br></p><p><span style="color: black;">Please note that this scholarship, is subject to you maintaining your academic performance and attendance record. It is your responsibility to provide evidence of this.&nbsp;</span></p><p><br></p><p><strong>All communication with you will be through your portal, you will have access to it for the entire time that we are giving you financial assistance.&nbsp;&nbsp;Please note that we will not respond to emails.</strong></p><p><br></p><p><span style="color: black;">To assist us with a timely remittance of your tuition fees you are required to log in to your portal and upload:</span></p><ul><li>Your<strong> mark sheet each semester </strong>before a payment can be made for a subsequent term. Failure to do this will result in a delay in your payment.</li><li><span style="color: black;">Inform Shukre Ilahi of your </span><strong>fee due</strong> <strong>date</strong> as soon as it is sent to you each semester, failure to send us fee due dates in a timely manner will result in you not getting your fees paid.</li></ul><p><br></p><p>Payments for subsequent years will depend on the availability of funds and, therefore subject to change.</p><p><span style="color: black;">Your fees will be sent directly to your institution from our local agents.&nbsp;</span></p><p><br></p><p><span style="color: black;">Visit <a href="https://app.shukreilahi.org/assets/Moeen.pdf">https://app.shukreilahi.org/assets/Moeen.pdf</a>&nbsp;Print the form and fill in your details.&nbsp;&nbsp;Send a hard copy of the form and all required documents by courier or registered post to Moeen’s office.&nbsp;</span></p><p><br></p><p><span style="color: black;">We, at Shukre Ilahi, strongly feel that lack of funds should not be a barrier for a good and deserving student to achieve academic success. Therefore, we encourage you to help other students, such as yourself, by donating back to the Shukre Ilahi Scholarship Fund once you graduate and can do so. When you are ready to donate back, please contact us for details of your local Shukre Ilahi agents.</span></p><p><br></p><p><span style="color: black;">Our Best Wishes are always with you for continued success in your chosen career path.</span></p><p><br></p><p><span style="color: black;">Salaams, </span></p><p><span style="color: black;">The Shukre Ilahi Board.</span></p>`,
      Rejected: `<p>Dear ${fullname}</p><p>&nbsp;</p><p>We would like to thank you for your application for a Shukre Ilahi scholarship.</p><p><br></p><p>We regret to inform you that after carefully reviewing your application and information provided, your scholarship application was not successful.</p><p><br></p><p>We wish you the very best in your pursuit of higher education.</p><p><br></p><p>Sincerely,</p><p>The Shukre Ilahi Committee</p>`,
      Hold: `<p>Dear ${fullname}</p><p><br></p>`,
      Process: ``,
      Returning: ``,
      Graduated: ``,
    }
    if (value === "Accepted") {
      if(formDataState?.personal?.country === "PK" || formDataState?.personal?.country === "Pakistan"){
        // console.log("Pakistan email")
        setrecommendationValues(predefinedValues.AcceptedPK)
      } else if(formDataState?.personal?.country === "IN" || formDataState?.personal?.country === "India"){
        // console.log("india email")
        setrecommendationValues(predefinedValues.AcceptedIN)
      } else {
        // console.log("other email")
        setrecommendationValues(predefinedValues.Accepted)
      }
    } else if (value === "Hold") {
      setrecommendationValues(predefinedValues.Hold)
    } else if (value === "Rejected") {
      setrecommendationValues(predefinedValues.Rejected)
    } else if (value === "In Process") {
      setrecommendationValues(predefinedValues.Process)
    } else if (value === "Returning") {
      setrecommendationValues(predefinedValues.Returning)
    } else if (value === "Graduated") {
      setrecommendationValues(predefinedValues.Graduated)
    }
  }

  const handleRecommendation = () => {
    // Safety net: don't submit if the applicant details haven't loaded.
    if (!canUpdateStatus) {
      Notify("error", "Applicant details are still loading. Please try again.")
      return
    }
    let data = {
      studentId: currentApplicationSelected?.id,
      status: recommendationStatusUpdate?.type,
      sentEmail:
        recommendationStatusUpdate?.type === "Graduated" ||
        recommendationStatusUpdate?.type === "In Process" ||
        recommendationStatusUpdate?.type === "Hold" ||
        recommendationStatusUpdate?.type === "Returning"
          ? false
          : true,
      message:
        recommendationStatusUpdate?.type === "Graduated" ||
        recommendationStatusUpdate?.type === "In Process" ||
        recommendationStatusUpdate?.type === "Hold" ||
        recommendationStatusUpdate?.type === "Returning"
          ? ""
          : recommendationValues,
      rejectionCode:
        recommendationStatusUpdate?.type === "Rejected"
          ? Number(recommendationStatusUpdate?.errorCode)
          : null,
    }
    // // console.log("data for recom api", data)
    dispatch(SendRecommendation(data))
      .then(res => {
        // // console.log("recommendation response %", res)
        if (res?.payload?.status === 200) {
          setRecommendationState(false)
          setRecommendationStatusUpdate(prev => ({
            ...prev,
            errorCode: 0,
          }))
        }
      })
      .catch(err => {
        // console.log(err)
      })
  }

  const handleDiscrepant = async () => {
    if (applicationId) {
      let data = {
        stdId: applicationId,
        discrepantStatus: formDataState?.personal?.isDiscrepent,
        comments: "",
      }
      dispatch(DiscripantApplication(data))
        .then(res => {
          if (res.payload.status === 200) {
            // // console.log("response editable status", res)
            setDiscrepant(prev => ({
              ...prev,
              comments: "",
            }))
            setDiscrepantModalState(false)
          } else {
            // // console.log("error in updating status")
            handleChangeInfo(
              "personal",
              "isDiscrepent",
              currentApplicationSelected?.isDiscrepent,
            )
          }
        })
        .catch(err => {
          // // console.log("error in updating status", err)
          handleChangeInfo(
            "personal",
            "isDiscrepent",
            currentApplicationSelected?.isDiscrepent,
          )
        })
    } else {
      Notify("error", "Invalid Application ID.")
    }
  }

  useEffect(() => {
    // console.log("loading application details......", staffMembersData)
    if (applicationId) {
      const detailFetchThunk = props?.isReturning
        ? ReturningStudentDetailFetch
        : ApplicationFetch
      dispatch(detailFetchThunk(applicationId))
        .then(async resp => {
          try {
          let _currentUser = await getUserTokenID()
          const _body = resp?.payload?.data
          // console.log("detail raw body ->", _body)
          // The returning-student endpoint nests the student object differently
          // than the applications endpoint, so resolve it across the known shapes.
          let responseData =
            _body?.studentInfo ||
            _body?.data?.studentInfo ||
            _body?.data ||
            _body
          let _staffAssigned = responseData?.staffAssigned || []
          // // console.log("resp of$$", responseData)
          let shortDetails = {
            id: applicationId,
            isOldStudent: responseData?.isOldStudent || false,
            applicationId: responseData?.applicationId || 0,
            applicationStatus: responseData?.applicationStatus || "",
            firstName: responseData?.firstName || "",
            middleName: responseData?.middleName || "",
            lastName: responseData?.lastName || "",
            phoneNumber: responseData?.phoneNumber || "",
            homeAddress: responseData?.homeAddress || "",
            email: responseData?.email || "",
            dateOfBirth: responseData?.dateOfBirth || "",
            submittedDate: responseData?.submittedDate || "",
            instituteName: responseData?.instituteName || "",
            isDiscrepent: responseData?.isDiscrepent || false,
            comments: responseData?.comments || "",
            annualIncome: responseData?.household?.annualIncome || 0,
            programDuration: responseData?.instituteInfo?.programDuration || "",
            staffAssigned: responseData?.staffAssigned || [],
          }
          // Set the selected application FIRST so the Application Id and the
          // recommendation email name are always populated, even if the mapping
          // below fails for a particular data shape.
          dispatch(SelectingCurrentApplication(shortDetails))

          if (_staffAssigned?.length > 0 && staffMembersData?.length > 0) {
            let _assignedStaffProfileIds = staffMembersData
              .filter(e => _staffAssigned?.includes(e?.id))
              .map(e => e?.profileId)

            _assignedStaffProfileIds?.includes(_currentUser)
              ? setStaffAssigned(true)
              : setStaffAssigned(false)
          } else {
            setStaffAssigned(false)
          }

          // Mapping is isolated so a mapping error can't skip the state set above.
          try {
            let transformedData = MapDataToApplicationState(responseData)
            // console.log("transformedData", transformedData)
            setFormDataState(transformedData)
          } catch (mapErr) {
            // Data loaded but could not be mapped/rendered — stay on the page
            // console.log("error mapping application details", mapErr)
          }
          } catch (mapErr) {
            // Data loaded but could not be mapped/rendered — stay on the page
            // console.log("error handling application details", mapErr)
          }
        })
        .catch(error => {
          navigate(props?.backPath || "/applications")
        })
    } else if (
      props?.applicationData &&
      Object.keys(props?.applicationData).length !== 0 &&
      !loading
    ) {
      let transformedData = MapDataToApplicationState(props?.applicationData)
      // console.log("singleApplicationDetail", transformedData)
      setFormDataState(transformedData)
    }
  }, [props?.applicationData])

  useEffect(() => {
    findUserRole()
    // console.log("application questions")
    if (_recommendationParamFlag) {
      setTabSwitch("recommendation")
    }
    // Notification -> Message Applicants tab
    if (_focusParam === "chat") {
      setTabSwitch("chat")
    }
    dispatch(ApplicationQuestions())
    if (applicationId) {
      dispatch(GetMiscellaneousDocs(applicationId))
    }
  }, [])

  // Notification -> scroll to the Documents Details section once the form data
  // has rendered.
  useEffect(() => {
    if (_focusParam === "documents" && !hasScrolledToDocs.current) {
      const t = setTimeout(() => {
        const el = document.getElementById("documents-details-section")
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" })
          hasScrolledToDocs.current = true
        }
      }, 400)
      return () => clearTimeout(t)
    }
  }, [_focusParam, formDataState])

  const handleChangeInfo = useCallback((parentObjectName, fieldName, value) => {
    // console.log(fieldName, "change to", value)
    setFormDataState(prevState => ({
      ...prevState,
      [parentObjectName]: {
        ...prevState[parentObjectName],
        [fieldName]: value,
      },
    }))
  }, [])

  const handleFileChange = useCallback((parentObjectName, fieldName, event) => {
    const file = event.target.files[0]
    // console.log(fieldName, "change to", file)
    setFormDataState(prevState => ({
      ...prevState,
      [parentObjectName]: {
        ...prevState[parentObjectName],
        [fieldName]: [...prevState[parentObjectName][fieldName], file],
      },
    }))
  }, [])

  const handleFileRemove = useCallback((parentObjectName, fieldName) => {
    // console.log(parentObjectName, "->", fieldName, "remove")
    setFormDataState(prevState => ({
      ...prevState,
      [parentObjectName]: {
        ...prevState[parentObjectName],
        [fieldName]: [],
      },
    }))
  }, [])

  const handleSubmit = () => {}
  const toggle = () => setOpenDropdown(prevState => !prevState)

  return (
    <div className="row">
      <div className="col-12">
        <button
          className="switch-btn-sm float-end"
          onClick={() => {
            if (applicationId) {
              // props.toggleTab()
              // navigate(-1)
              if (window.history.state && window.history.state.idx > 0) {
                navigate(-1)
              } else {
                navigate(props?.backPath || "/applications")
              }
            }
          }}
        >
          Back
        </button>
      </div>
      <div
        className={`col-sm-12 ${
          props?.hideSidebar ? "col-md-12" : "col-md-8"
        } mb-4 form-left-details`}
      >
        <div>
          <div className="card p-2 position-relative">
            <div className="position-relative" style={{ height: "85px" }}>
              {
                !isViewer && !props?.hideSidebar && (
                  <div
                    className="position-absolute top-0 end-0 d-flex flex-wrap justify-content-end"
                    style={{ maxWidth: "45%" }}
                  >
                    {/* <button className="btn btn-info btn-sm rounded-pill mb-1 me-1" onClick={()=>{
                      setDiscrepantModalState(true)
                      // setSelectedId("")
                      setDiscrepant(prev => ({
                        ...prev,
                        status: formDataState.personal?.isDiscrepent ? "Yes" : "No",
                      }))
                    }}>Editable</button> */}
                    <div
                      className="ms-1 mb-1 bg-success rounded-pill d-flex justify-content-center align-items-center"
                      onClick={e => {
                        setDiscrepantModalState(true)
                        handleChangeInfo(
                          "personal",
                          "isDiscrepent",
                          !formDataState?.personal?.isDiscrepent,
                        )
                      }}
                    >
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="switchCheckChecked"
                          // onClick={e => {
                          //   setDiscrepantModalState(true)
                          //   handleChangeInfo(
                          //     "personal",
                          //     "isDiscrepent",
                          //     !formDataState?.personal?.isDiscrepent,
                          //   )
                          // }}
                          checked={formDataState?.personal?.isDiscrepent}
                        />
                        <p
                          className="form-check-label text-white"
                          for="switchCheckChecked"
                        >
                          Editable
                        </p>
                      </div>
                    </div>
                    {/* <button className="btn btn-info btn-sm rounded-pill mb-1 me-1" onClick={handleOpenMiscDocs}>Miscellaneous</button> */}
                    {(role === "Admin" || staffAssigned) && (
                      <Dropdown
                        isOpen={openDropdown}
                        toggle={toggle}
                        className="ms-1 mb-1 btn-sm ps-1"
                        // className="float-end me-2 position-absolute top-0 end-0"
                      >
                        <DropdownToggle
                          caret
                          disabled={!canUpdateStatus}
                          title={
                            !canUpdateStatus
                              ? "Applicant details are still loading"
                              : undefined
                          }
                          className="btn btn-danger btn-sm"
                          style={{ borderRadius: "50px" }}
                        >
                          Update Status
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem
                            style={{ backgroundColor: "#49ecc0" }}
                            className="text-black fs-5"
                            onClick={() => {
                              setRecommendationState(true)
                              handleSelectRecommendationChange(
                                currentApplicationSelected?.id,
                                "Accepted",
                              )
                            }}
                          >
                            Accept
                          </DropdownItem>
                          <DropdownItem
                            style={{ backgroundColor: "#ffcfce" }}
                            className="text-black fs-5"
                            onClick={() => {
                              setRecommendationState(true)
                              handleSelectRecommendationChange(
                                currentApplicationSelected?.id,
                                "Hold",
                              )
                            }}
                          >
                            Hold
                          </DropdownItem>
                          <DropdownItem
                            style={{ backgroundColor: "#ff8f8e" }}
                            className="text-black fs-5"
                            onClick={() => {
                              setRecommendationState(true)
                              handleSelectRecommendationChange(
                                currentApplicationSelected.id,
                                "Rejected",
                              )
                            }}
                          >
                            Reject
                          </DropdownItem>
                          <DropdownItem
                            style={{ backgroundColor: "#b1fae8" }}
                            className="text-black fs-5"
                            onClick={() => {
                              setRecommendationState(true)
                              handleSelectRecommendationChange(
                                currentApplicationSelected.id,
                                "In Process",
                              )
                            }}
                          >
                            In Process
                          </DropdownItem>
                          <DropdownItem
                            style={{ backgroundColor: "#f8fd99" }}
                            className="text-black fs-5"
                            onClick={() => {
                              setRecommendationState(true)
                              handleSelectRecommendationChange(
                                currentApplicationSelected.id,
                                "Returning",
                              )
                            }}
                          >
                            Returning
                          </DropdownItem>
                          <DropdownItem
                            style={{ backgroundColor: "#45b39d" }}
                            className="text-black fs-5"
                            onClick={() => {
                              setRecommendationState(true)
                              handleSelectRecommendationChange(
                                currentApplicationSelected.id,
                                "Graduated",
                              )
                            }}
                          >
                            Graduated
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    )}
                  </div>
                )
              }
              <div className="" style={{ maxWidth: "55%" }}>
                <div className="row">
                  <label className="col-12 ms-4 fs-6 d-inline lh-sm">
                    Current Recipient of Shukre Ilahi:
                    <span className="fw-bold">
                      {" "}
                      {formDataState.personal?.isOldStudent ? "Yes" : "No"}
                    </span>
                  </label>
                  <label className="col-12 ms-4 fs-6 d-inline lh-sm">
                    Application Id:
                    <span className="fw-bold">
                      {" "}
                      {currentApplicationSelected?.applicationId}
                    </span>
                  </label>
                  <label className="col-12 ms-4 fs-6 d-inline lh-sm">
                    Status:{" "}
                    <span className="fw-bold">
                      {" "}
                      {currentApplicationSelected?.applicationStatus}
                    </span>
                  </label>
                </div>
              </div>
              <Modal isOpen={recommendationState} centered size="lg">
                <Card className="bg-white">
                  <CardBody className="mt-2">
                    {recommendationStatusUpdate?.type === "Graduated" ||
                    recommendationStatusUpdate?.type === "In Process" ||
                    recommendationStatusUpdate?.type === "Hold" ||
                    recommendationStatusUpdate?.type === "Returning" ? (
                      <p className="fs-4 text-black">
                        Are you sure to mark this application as{" "}
                        {recommendationStatusUpdate?.type}?
                      </p>
                    ) : (
                      <ReactQuill
                        value={recommendationValues}
                        onChange={e => handlerecommendationValuesChange(e)}
                      />
                    )}
                    {recommendationStatusUpdate?.type === "Rejected" && (
                      <SelectFieldForId
                        className="col-sm-12 col-md-12 col-lg-12 mt-4"
                        label="Rejection Code"
                        compulsory={true}
                        disabled={false}
                        selectOptions={[
                          { id: 0, name: "No Response" },
                          { id: 1, name: "Income too High" },
                          { id: 2, name: "Studying Abroad" },
                          { id: 3, name: "Other" },
                        ]}
                        value={
                          recommendationStatusUpdate?.errorCode
                            ? recommendationStatusUpdate?.errorCode
                            : 0
                        }
                        placeholder="Type Currency"
                        onChange={e =>
                          setRecommendationStatusUpdate(prev => ({
                            ...prev,
                            errorCode: e.target.value,
                          }))
                        }
                      />
                    )}
                  </CardBody>
                  <CardFooter>
                    <div className="mt-4 float-end">
                      <button
                        className="btn btn-danger me-2"
                        disabled={loading}
                        onClick={handleRecommendation}
                      >
                        Ok
                      </button>
                      <button
                        className="btn btn-primary"
                        disabled={loading}
                        onClick={() => {
                          setRecommendationState(false)
                          setrecommendationValues("")
                          setRecommendationStatusUpdate(prev => ({
                            ...prev,
                            errorCode: 0,
                          }))
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </CardFooter>
                </Card>
              </Modal>
              <Modal
                isOpen={miscDocsModalState}
                onClosed={() => {}}
                size="lg"
                centered
              >
                <MiscDocs close={handleCloseMiscDocs} />
              </Modal>
              <Modal
                isOpen={discrepantModalState}
                onClosed={() => setSelectedId("")}
                centered
              >
                <Card className="bg-white">
                  <CardBody className="mt-2">
                    <h5 className="mb-2" style={{ fontWeight: "normal" }}>
                      Are You Sure. You want to make{" "}
                      <span className="fw-bold">
                        {formDataState?.personal?.firstName +
                          " " +
                          formDataState?.personal?.middleName +
                          " " +
                          formDataState?.personal?.lastName}
                      </span>{" "}
                      application{" "}
                      <span className="fw-bold">
                        {formDataState?.personal?.isDiscrepent
                          ? "Editable"
                          : "Uneditable"}
                      </span>
                      ?
                    </h5>
                    {/* <SelectFieldForId
                      className="col-sm-12 col-md-12 col-lg-12 my-2"
                      label="Editable"
                      compulsory={true}
                      disabled={false}
                      selectOptions={[
                        { id: "No", name: "No" },
                        { id: "Yes", name: "Yes" },
                      ]}
                      value={!discrepant.status ? "No" : discrepant?.status}
                      placeholder="Type Currency"
                      onChange={e =>
                        setDiscrepant(prev => ({
                          ...prev,
                          status: e.target.value,
                        }))
                      }
                    /> */}
                  </CardBody>
                  <CardFooter>
                    <div className="mt-4 float-end">
                      <button
                        className="btn btn-danger me-2 w-md h-md"
                        disabled={statusUpdateLoading}
                        onClick={() => handleDiscrepant()}
                      >
                        {/* Ok */}
                        {statusUpdateLoading ? (
                          <div
                            className="spinner-border"
                            role="status"
                            style={{ height: "16px", width: "16px" }}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          "Ok"
                        )}
                      </button>
                      <button
                        className="btn btn-primary w-md h-md"
                        disabled={statusUpdateLoading}
                        onClick={() => {
                          setDiscrepantModalState(false)
                          handleChangeInfo(
                            "personal",
                            "isDiscrepent",
                            currentApplicationSelected?.isDiscrepent,
                          )
                          // setDiscrepant(prev => ({
                          //   ...prev,
                          //   status: "",
                          //   comments: "",
                          // }))
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </CardFooter>
                </Card>
              </Modal>
            </div>
            <div className="application-form-details">
              <div className="card-body" id="application-form">
                <div className="card-title fs-3 my-2">Application Details</div>
                {loading ? (
                  <Loader />
                ) : (
                  <div className="row">
                    <PersonalInfoForm
                      handleChangeInfo={handleChangeInfo}
                      personalInfo={formDataState.personal}
                      forView={forView}
                    />
                    <AcademicsInfoForm
                      handleChangeInfo={handleChangeInfo}
                      academicsInfo={formDataState.academics}
                      forView={forView}
                    />
                    <EducationExpensesInfoForm
                      handleChangeInfo={handleChangeInfo}
                      educationExpenseInfo={formDataState.educationExpenses}
                      academicsInfo={formDataState.academics}
                      forView={forView}
                    />
                    <DocumentsInfoForm
                      handleChangeInfo={handleChangeInfo}
                      handleFileChange={handleFileChange}
                      handleFileRemove={handleFileRemove}
                      documentsInfo={formDataState.documents}
                      forView={forView}
                      componentFor={props?.for || "View"}
                      role={role}
                    />
                    <ReferenceInfoForm
                      handleChangeInfo={handleChangeInfo}
                      community={formDataState.refernce}
                      forView={forView}
                    />
                    <AuthorizationInfoForm
                      handleChangeInfo={handleChangeInfo}
                      handleFileChange={handleFileChange}
                      handleFileRemove={handleFileRemove}
                      authorizationInfo={formDataState.authorization}
                      forView={forView}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {!props?.hideSidebar && (
      <div className="col-sm-12 col-md-4 mb-2">
        {/* <div className="row"> */}
        {(props?.for === "View" || applicationId) && (
          <div className="card" style={{ height: "auto" }}>
            <ul className="nav nav-pills nav-justified custom-nav mt-1 mb-1">
              <li className="nav-item">
                <Link
                  className={`nav-link ${tabSwitch === "notes" ? "active-notes" : "inactive-notes"}`}
                  onClick={() => setTabSwitch("notes")}
                >
                  Internal Notes
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${tabSwitch === "recommendation" ? "active-recommendations" : "inactive-recommendations"}`}
                  onClick={() => setTabSwitch("recommendation")}
                >
                  Recommendation
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${tabSwitch === "chat" ? "active-chat" : "inactive-chat"}`}
                  onClick={() => setTabSwitch("chat")}
                >
                  Message Applicants
                </Link>
              </li>
            </ul>
            <div className={`${tabSwitch === "notes" ? "d-block" : "d-none"}`}>
              <ApplicationComments userRole={userRole} />
            </div>
            <div
              className={`${tabSwitch === "recommendation" ? "d-block" : "d-none"}`}
            >
              <ApplicationRecommendation userRole={userRole} />
            </div>
            <div className={`${tabSwitch === "chat" ? "d-block" : "d-none"}`}>
              <SideChat tabSwitch={tabSwitch} userRole={userRole} />
            </div>
            {/* <div>
                  {
                    tabSwitch === "notes" && (
                      <ApplicationComments />
                    )
                  }
                  {
                    tabSwitch === 'chat' && (
                      <div>
                        <SideChat />
                      </div>
                    )
                  }
                </div> */}
          </div>
        )}
        {/* </div> */}
        {/* <div className="row">
            <div className="card">
              <div className="card-body"  style={{height: "400px"}}></div>
            </div>
          </div> */}
      </div>
      )}
    </div>
  )
}
